"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiCheckbox = void 0;
var styles_1 = require("@material-ui/core/styles");
var palette_1 = require("../../../theme/global/palette");
exports.MuiCheckbox = {
    root: {
        padding: 6,
        margin: '-1px 2px -1px 0',
        color: palette_1.palette.grey[500],
        '&$checked': {
            '&.Mui-focusVisible': {
                backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.main, 0.1),
            },
            '&.MuiSvgIcon': {
                color: palette_1.palette.error.main,
                backgroundColor: palette_1.palette.error.main,
            },
        },
        '&.Mui-focusVisible': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.grey[500], 0.1),
        },
    },
    indeterminate: {
        color: palette_1.palette.primary.main,
    },
    colorPrimary: {
        '&:hover': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.grey[500], 0.1),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&:active': {
            backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.main, 0.1),
        },
        '&$checked': {
            color: palette_1.palette.primary.main,
            '&.MuiSvgIcon': {
                color: palette_1.palette.error.main,
                backgroundColor: palette_1.palette.error.main,
            },
            '&:hover': {
                backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.main, 0.1),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent',
                },
            },
            '&:active': {
                backgroundColor: (0, styles_1.alpha)(palette_1.palette.primary.main, 0.1),
            },
        },
        '&.Mui-disabled': {
            color: palette_1.palette.grey[400],
        },
    },
};
